export default {
    data() {
        return {
            pt: {
                listen: 'Escute nas Plataformas',
                pre_save: 'Faça o Pré-save',
                share: 'Compartilhar',
                access: 'Acessar',
                copy: 'Copiar',

                // tabs
                recommendations: 'Recomendações',
                lyrics: 'Letra',
                info: 'Informações',

                // informations
                info_tech: 'Ficha Técnica',
                autors: 'Autores',
                main_genre: 'Gênero Principal',
                secondary_genre: 'Gênero Secundário',
                code_ISRC: 'Código ISRC',
                code_UPC: 'Código UPC',

                close: 'Fechar',
                info_close: 'Texto copiado',
            },
            en: {
                listen: 'Listen on platforms',
                pre_save: 'Do it pre-save',
                share: 'Share',
                access: 'Access',
                copy: 'Copy',

                // tabs
                recommendations: 'Recommendations',
                lyrics: 'Lyrics',
                info: 'Informations',

                // informations
                info_tech: 'Document Technical File',
                autors: 'Autors',
                main_genre: 'Main Genre',
                secondary_genre: 'Secondary Genre',
                code_ISRC: 'Code ISRC',
                code_UPC: 'Code UPC',

                close: 'Close',
                info_close: 'Copied text',
            },
            it: {
                listen: 'Ascolta sulle piattaforme',
                pre_save: 'Fai il pre-save',
                share: 'Condividi',
                access: 'Accedi',
                copy: 'Copia',

                // tabs
                recommendations: 'Raccomandazioni',
                lyrics: 'Testo',
                info: 'Informazioni',

                // informations
                info_tech: 'Scheda Tecnica',
                autors: 'Autori',
                main_genre: 'Genere Principale',
                secondary_genre: 'Genere Secondario',
                code_ISRC: 'Codice ISRC',
                code_UPC: 'Codice UPC',

                close: 'Chiudi',
                info_close: 'Testo copiato',
            }
        }
    }
}
